import { Component, OnInit } from "@angular/core";
import { VisitasService } from "../../services/visitas.service";

@Component({
  selector: "modal-outras-info",
  templateUrl: "./modal.outras.info.html",
  styleUrls: ["./modal.outras.info.css"]
})
export class ModalOutrasInfoComponent implements OnInit {
  textLeft="";
  textRight="";
  lsItems=[];
  isRequesting=false;

  constructor(private visitService: VisitasService) {
  }

  ngOnInit() {}

  setInformations(textLeft:string, textRight:string, idCliente){
    this.isRequesting=true;
    this.textLeft = textLeft;
    this.textRight = textRight;
    this.lsItems=[];

    this.visitService.getClienteById(idCliente).subscribe(
      resp => {
        this.lsItems = resp;
        this.isRequesting=false;
      },
      error => {
        console.log(error)
        this.isRequesting=false;
      }
    )
 
    document.getElementById("openModalButton").click();
  }
}
